// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__ZpMIn","input":"Form_input__dwvcn","divider":"Form_divider__2q0l7","actions":"Form_actions__u58Ca","footer":"Form_footer__glTMG","forgot":"Form_forgot__1_u8B"};